import React, { useState } from 'react'
import styles from './Scope.module.scss'
import { IconButton, Input } from 'components/common'
import { IconAddFilter, IconPencil, IconBin } from 'assets'
import ScopeFilter from './ScopeFilter'
import { ScopeProps } from './Scope.types'

const newFilterTemplate = {
  type: '',
  values: '',
  projects: [],
  brands: [],
  products: []
}

const ScopeComponent = (props: ScopeProps) => {
  const { remove, scope, setScopeProp } = props
  const isScopeNew = scope.hasOwnProperty('id')
  const [editName, setEditName] = useState(!isScopeNew)

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {editName
          ? (
            <Input
              size='mini'
              autoFocus
              onBlur={() => setEditName(false)}
              value={scope.name}
              onChange={name => setScopeProp({ name })}
              className={styles.scopeNameInput}
            />
          )
          : <span>{scope.name}</span>
        }

        <IconButton
          className={styles.titleIcon}
          svgProps={{ fill: styles.borderGrey, opacity: 0.6 }}
          icon={IconAddFilter}
          onClick={() => setScopeProp({ filters: [...scope.filters, newFilterTemplate] })}
        />
        <IconButton
          className={styles.titleIcon}
          svgProps={{ fill: styles.borderGrey, opacity: 0.6 }}
          icon={IconPencil}
          onClick={() => setEditName(true)}
        />
        <IconButton
          className={styles.titleIcon}
          svgProps={{ fill: styles.borderGrey, opacity: 0.6 }}
          icon={IconBin}
          onClick={remove}
        />
      </div>

      {scope.filters.map((filter, index) => {
        return (
          <ScopeFilter
            key={index}
            filter={filter}
            setFilterProp={newProps => {
              const newFilters = [...scope.filters]
              newFilters[index] = { ...newFilters[index], ...newProps }
              setScopeProp({ filters: newFilters })
            }}
          />
        )
      })}
    </div>
  )
}

const Scope = ScopeComponent
export { Scope }
